var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("menu-obchod", {
        attrs: { kravicka: _vm.kravicka, sideMenu: _vm.sideMenu },
        on: { hideSideMenu: _vm.hideSideMenu }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn --primary d-xl-none",
          staticStyle: { "z-index": "61" },
          attrs: { id: "openShopMenu" },
          on: {
            click: function($event) {
              _vm.sideMenu = !_vm.sideMenu
            }
          }
        },
        [_c("span", { staticClass: "icon" })]
      ),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "shopMain --lightBg" },
        [
          _c(
            "div",
            { staticClass: "shopHeader --whiteBg d-flex" },
            [
              _c("h2", { staticClass: "mb-0" }, [_vm._v("Obchod")]),
              _vm._v(" "),
              _c("header-obchod", {
                attrs: { profil: _vm.profil },
                on: { updateProfil: _vm.emitUpdateProfil }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.responseText != ""
            ? _c(
                "div",
                {
                  class:
                    "alert alert-dismissible fade show --shopAlert alert-" +
                    _vm.responseType,
                  attrs: { role: "alert" }
                },
                [
                  _c("p", { staticClass: "mb-0" }, [
                    _c("span", { class: "icon --" + _vm.responseType }),
                    _vm._v(_vm._s(_vm.responseText) + "\n            ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: {
                        type: "button",
                        "data-dismiss": "alert",
                        "aria-label": "Close"
                      },
                      on: {
                        click: function($event) {
                          _vm.responseText = ""
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { "aria-hidden": "true" } }, [
                        _vm._v("×")
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("obchod-product-grid", {
            attrs: { obchod: _vm.obchod, kategoria: _vm.kategoria },
            on: { buyProduct: _vm.buyShopProduct }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }